import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { MapContainer, TileLayer, Polyline, useMap, CircleMarker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { X } from 'lucide-react';

const RecenterMap = ({ path }) => {
  const map = useMap();
  useEffect(() => {
    // Small delay to ensure container has settled
    const timer = setTimeout(() => {
      map.invalidateSize();
    }, 200);

    if (path && path.length > 0) {
      const bounds = path.map(p => [p.lat, p.lng]);
      map.fitBounds(bounds, { padding: [50, 50] });
    }
    return () => clearTimeout(timer);
  }, [path, map]);
  return null;
};

const RouteViewer = ({ path, onClose }) => {
  const { t } = useTranslation();

  if (!path || path.length === 0) return null;

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-start justify-center p-4 bg-black/80 backdrop-blur-sm overflow-y-auto pt-10">
      <div className="bg-[#1c1c1e] w-full max-w-2xl rounded-2xl overflow-hidden border border-gray-800 shadow-2xl flex flex-col h-[70vh] md:h-[80vh]">
        <div className="p-4 border-b border-gray-800 flex justify-between items-center bg-[#1c1c1e] z-10">
          <h3 className="text-lg font-bold text-white">{t('tracking.route_history')}</h3>
          <button 
            onClick={onClose}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <X className="text-gray-400" size={24} />
          </button>
        </div>
        
        <div className="flex-1 relative">
          <MapContainer 
            center={[path[0].lat, path[0].lng]} 
            zoom={16} 
            style={{ height: '100%', width: '100%' }}
            zoomControl={true}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Polyline positions={path.map(p => [p.lat, p.lng])} color="#f43f5e" weight={5} />
            
            {/* Start Pin */}
            <CircleMarker 
              center={[path[0].lat, path[0].lng]} 
              radius={8}
              pathOptions={{ color: 'white', fillColor: '#10b981', fillOpacity: 1, weight: 2 }} 
            />
            
            {/* End Pin */}
            <CircleMarker 
              center={[path[path.length - 1].lat, path[path.length - 1].lng]} 
              radius={8}
              pathOptions={{ color: 'white', fillColor: '#ef4444', fillOpacity: 1, weight: 2 }} 
            />
            
            <RecenterMap path={path} />
          </MapContainer>
        </div>
        
        <div className="p-4 bg-gray-900 border-t border-gray-800 text-center">
          <button 
            onClick={onClose}
            className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-2 rounded-lg font-bold transition-all"
          >
            {t('close')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default RouteViewer;
